import translations from '@eworx/ckeditor5/translations/de.js';

translations.de.dictionary = {
    ...translations.de.dictionary,
    'WhatsAppOptInKeyword': 'Schlüsselwort für Anmeldung',
    'WhatsAppOptOutKeyword': 'Schlüsselwort für Abmeldung',
    'WhatsAppProfileName': 'WhatsApp Profil-Name',
}

export default translations;